<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M16.25 2L18.025 3.775L9.79999 12L18.025 20.225L16.25 22L6.24999 12L16.25 2Z" fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>